import { render, staticRenderFns } from "./block-controller.vue?vue&type=template&id=3e36d357"
import script from "./block-controller.vue?vue&type=script&lang=ts"
export * from "./block-controller.vue?vue&type=script&lang=ts"
import style0 from "./block-controller.vue?vue&type=style&index=0&id=3e36d357&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports